import { Navigate, Outlet } from 'react-router-dom'

import { getOlPermissions } from '../../lib/constants/ol-permissions'
import { Paths } from '../../lib/constants/path'
import useAuth from '../../lib/hooks/use-auth'

export default function OlGuard() {
  const { user } = useAuth()

  const permissions = getOlPermissions({ type: user.ol?.type, role: user.role })
  const hasPermission = permissions['ol-personal-space']

  return hasPermission ? <Outlet /> : <Navigate replace to={Paths.AUTH_LOGOUT_PAGE} />
}
